import OrdersTable from "./OrdersTable";

const FakeCustomerOrder = () => {
  return <OrdersTable type="fake-customer-order" />;
};

export default FakeCustomerOrder;
